const ExampleListData = {
  title: {
    pl: "Wpisz wycenę z naszej oferty lub skorzystaj z poniższych przykładów:",
    en: "Enter a quote from our offer or use the examples below:",
  },
  items: {
    pl: [
      "System do obsługi jednej referencji oparty na jednej kamerze 40-120k PLN",
      "System wielookamerowy: 120-350k PLN",
      "Automatyczne stanowisko kontroli: 300k-1,5mln PLN",
    ],
    en: [
      "System for handling one reference based on one camera 8-15k EUR",
      "Multi-camera system: 30-70k EUR",
      "Automatic control station: 80-150k EUR",
    ],
  },
};
export default ExampleListData;
